import { formateDateandTime } from 'helpers/formats';
import React from 'react';
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export default function ModalJustificativa({ visibilidadeModal, setVisibilidadeModal, item }) {
    return (
        <Modal isOpen={visibilidadeModal} toggle={setVisibilidadeModal} size={"lg"}>
            <ModalHeader toggle={setVisibilidadeModal}>Histórico de Justificativas</ModalHeader>
            <ModalBody>
                <Form>
                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th scope="col" className="">Data da Justificativa</th>
                                    <th scope="col">Observação</th>
                                    <th scope="col">Usuário</th>
                                </tr>
                            </thead>
                            <tbody>
                                {item !== null && item?.protocoloJustificativas.map((value, index) => (
                                    <tr key={index}>
                                        <td>{formateDateandTime(value.dataJustificativa)}</td>
                                        <td>{value.observacao}</td>
                                        <td>{value.usuario.nome ?? ""}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={setVisibilidadeModal}>OK</Button>
            </ModalFooter>
        </Modal>
    )
}